import Protocol from './Protocol';
import { Button, Divider, Form } from '../../components';
import { liftsSelector, protocolsSelector } from '../../orm/selectors';
import venueActions from '../../venue/actions';
import { bickActions } from '../../common';

import { connect } from 'react-redux';
import React, { Component } from 'react';
import { find, get, pick } from 'lodash';

class Director extends Component {
  state = {
    protocol: get(this.props.venue, 'competition.current.protocol'),
    lift: get(this.props.venue, 'competition.current.lift'),
  };

  onProtocolChange = (event, { value }) => {
    this.setState({
      protocol: value.length ? value : undefined,
      lift: undefined,
    });
  };

  onLiftChange = (event, { value }) =>
    this.setState({ lift: value.length ? value : undefined });

  onCompetitionBegin = () => {
    const { actions } = this.props;
    const { protocol, lift } = this.state;
    actions.venue.competition.begin(protocol, lift);
  };

  onCompetitionEnd = () => {
    const { actions } = this.props;
    actions.venue.competition.end();
  };

  onRefereeLightsReset = () => {
    const { actions } = this.props;
    actions.competition.refereeLights.reset();
  };

  onRefereeLightsShow = () => {
    const { actions } = this.props;
    actions.competition.refereeLights.show(['good-lift', 'no-lift', 'off']);
  };

  render() {
    const { /*app, route,*/ orm, venue } = this.props;

    const selected = pick(this.state, 'protocol', 'lift');

    const current = get(venue.competition, 'current', {});
    const isCompetitionActive = !!current.protocol && !!current.lift;
    const protocol = find(orm.protocols, { primaryKey: current.protocol });
    const lift = find(orm.lifts, { primaryKey: current.lift });
    return (
      <main>
        <h1>Director terminal</h1>
        <Form>
          <Form.Group>
            <Form.Select
              label="Protocol"
              options={orm.protocols.map(({ id, uuid, title }) => ({
                key: id,
                value: uuid,
                text: title,
              }))}
              placeholder="Select protocol"
              value={selected.protocol || ''}
              onChange={this.onProtocolChange}
              width={6}
              fluid
            />
            <Form.Select
              label="Lift"
              options={orm.lifts.map(({ id, uuid, title }) => ({
                key: id,
                value: uuid,
                text: title,
              }))}
              placeholder="Select lift"
              value={selected.lift || ''}
              onChange={this.onLiftChange}
              width={2}
              fluid
            />
            <Form.Field label="Actions" control={Button.Group}>
              <Button
                disabled={
                  isCompetitionActive || !selected.protocol || !selected.lift
                }
                content="Begin"
                onClick={this.onCompetitionBegin}
              />
              <Button
                disabled={!isCompetitionActive}
                content="End"
                onClick={this.onCompetitionEnd}
              />
            </Form.Field>
            <Form.Field label="Referee lights" control={Button.Group}>
              <Button content="Reset" onClick={this.onRefereeLightsReset} />
              <Button content="Show" onClick={this.onRefereeLightsShow} />
            </Form.Field>
          </Form.Group>
        </Form>
        <Divider />
        {protocol ? (
          <Protocol protocol={protocol} lift={lift} meta={{ orm }} />
        ) : (
          <p>No selected protocol.</p>
        )}
      </main>
    );
  }
}

Director.slug = 'director';
Director.title = 'Director';

const mapStateToProps = ({ orm, venue }) => ({
  venue,
  orm: {
    lifts: liftsSelector(orm),
    protocols: protocolsSelector(orm),
  },
});

const mapDispatchToProps = dispatch => ({
  actions: {
    venue: bickActions(venueActions, ['competition'], dispatch),
    competition: bickActions(
      venueActions.competition,
      ['refereeLights'],
      dispatch,
    ),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Director);



// WEBPACK FOOTER //
// ./src/terminals/Director/Director.js